import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 1H20V5H18V3H6V17H20V23H4V1ZM13.0039 19H11V21.0039H13.0039V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4551 14.506L21.8863 15.2869L21.1054 16.8557L20.3245 15.2869L18.7557 14.506L20.3245 13.7251L21.1054 12.1562L21.8863 13.7251L23.4551 14.506Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.9599 12.0966L16.057 14.3007L17.1541 12.0966L19.3581 10.9995L17.1541 9.90243L16.057 7.69839L14.9599 9.90243L12.7559 10.9995L14.9599 12.0966Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.4551 7.4962L21.8863 8.27709L21.1054 9.84589L20.3245 8.27709L18.7557 7.4962L20.3245 6.71529L21.1054 5.14648L21.8863 6.71529L23.4551 7.4962Z"}}]};

const MobileShortcutFilled = Vue.extend<IconProps>({
  name: 'MobileShortcutFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'mobile-shortcut-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default MobileShortcutFilled;
